import { useEffect } from 'react';
import { IUserInfo, WakeUp } from '../../../../common/interface/props';
import Swal from 'sweetalert2';
import { axiosCustom } from 'common/common.function';

interface IProps {
  solType: WakeUp;
  requiredLogin: boolean;
}

function LoginCheck({ solType, requiredLogin }: IProps) {
  useEffect(() => {
    // 로그인 정보 가져오기
    const rawUserInfo = sessionStorage.getItem('userInfo');

    // 로그인 데이터 파싱
    const userInfo: IUserInfo = rawUserInfo && JSON.parse(rawUserInfo);

    if (solType !== 'ADMIN') {
      // 로그인 필수 페이지 여부 상관 없이 솔타입 다르면 무조건 재로그인
      if (userInfo && solType !== userInfo.solType) {
        DoLogout();
      } else {
        if (requiredLogin) {
          // 로그인 필수 페이지
          if (!userInfo) {
            moveLogin();
          }
        } else {
          // 로그인 비필수 페이지
          if (userInfo) {
            moveShopLogin();
          }
        }
      }
    }

    async function moveLogin() {
      await Swal.fire({
        title: '확인',
        text: '로그인이 필요한 서비스입니다.',
        showConfirmButton: true,
      });

      window.location.href = `/${solType.toLowerCase()}/member/login?referUrl=${window.location.pathname}`;
    }
    async function moveShopLogin() {
      await Swal.fire({
        title: '확인',
        text: '이미 로그인이 되어 있습니다.',
        showConfirmButton: true,
      });

      window.location.href = `/${solType.toLowerCase()}/job/shop-login`;
    }

    async function DoLogout() {
      await axiosCustom.post(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/member/logout`);
      sessionStorage.removeItem('userInfo');
      moveLogin();
    }
  }, [requiredLogin, solType]);

  return <></>;
}
export default LoginCheck;
